import request from '@/utils/http'

const PREFIX = '/tenant'

const tenant = {
  create(params) {
    return request(
      `${PREFIX}`,
      'post',
      params
    )
  },

  update(id, params) {
    return request(
      `${PREFIX}/${id}`,
      'put',
      params
    )
  },

  show(id) {
    return request(
      `${PREFIX}/${id}`,
      'get'
    )
  },

  current() {
    return request(
      `${PREFIX}/current`,
      'get'
    )
  },

  updateCurrent(params) {
    return request(
      `${PREFIX}/current`,
      'put',
      params
    )
  },

  page(params) {
    return request(
      `${PREFIX}`,
      'get',
      params
    )
  },

  list() {
    return request(
      `${PREFIX}/list`,
      'get'
    )
  },

  enable(id) {
    return request(
      `${PREFIX}/${id}/enable`,
      'put'
    )
  },

  disable(id) {
    return request(
      `${PREFIX}/${id}/disable`,
      'put'
    )
  },
  sign() {
    return request(
      `${PREFIX}/sign`,
      'get'
    )
  },
  saveSign(params) {
    return request(
      `${PREFIX}/sign`,
      'post',
      params
    )
  },
  updateSign(params) {
    return request(
      `${PREFIX}/sign`,
      'put',
      params
    )
  },
  listUserTenants(params) {
    return request(
      `${PREFIX}/page/userTenant`,
      'get',
      params
    )
  },

  selTenant(id) {
    return request(
      `${PREFIX}/selTenant/${id}`,
      'put'
    )
  },

  signAuthorizeProjects(params) {
    return request(
      `${PREFIX}/sign/authorizeProjects`,
      'post',
      params
    )
  },

  signList(params) {
    return request(
      `${PREFIX}/sign/page`,
      'get',
      params
    )
  },

  getAuthorizedProjectIds(signId) {
    return request(
      `${PREFIX}/sign/authorized/${signId}`,
      'get'
    )
  }
}

export default tenant
